<template>
    <div class="GamesResults_children">
        <div class="screen_box">
            <label>日期</label>
            <el-select v-model="screen.date" placeholder="请选择比赛日期">
                <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
            </el-select>
            <label>单元</label>
            <el-select v-model="screen.session" placeholder="请选择比赛单元" clearable>
                <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
            </el-select>
            <label>场地</label>
            <el-select v-model="screen.court" placeholder="请选择比赛场地" clearable multiple>
                <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
            </el-select>
            <label>比赛状态</label>
            <el-select v-model="screen.status" placeholder="请选择比赛状态" clearable>
                <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
            </el-select>
            <div>
                <label>运动员名字</label>
                <el-input
                    placeholder="请输入运动员姓名"
                    prefix-icon="el-icon-search"
                    v-model="screen.name"
                    class="adb">
                </el-input>
            </div>
            
        </div>

        <div class="gameschildren_list">
            <el-collapse v-model="activeNames" @change="handleChange">
                <!-- 个人 -->
                <el-collapse-item name="1" :disabled="true" >
                    <template slot="title">
                        <div class="result_person">
                            <div class="status_game"></div>
                            <div class="person_second">
                                <div class="person_startTime person_secondOne">
                                    <div>开始时间：09:00</div>
                                    <div :style="{'height':'30px'}"></div>
                                    <div class="event_name">混合双打1/128淘汰赛</div>
                                </div>
                                <div class="person_startTime person_secondTwo">
                                    <P>MS-1</P>
                                </div>
                                <div class="person_startTime person_secondThree" :style="{'text-align':'right'}">
                                    <P>1号场地</P>
                                    <div :style="{'height':'30px'}"></div>
                                    <P class="event_name">主裁：<span>发球裁判</span>，发裁：<span>发球裁判</span></P>
                                </div>
                            </div>
                            <div class="person_startTime" :style="{'width':'13%','text-align':'center'}">
                                <P>北京</P>
                                <div class="name_athlete">
                                    <p>张三</p>
                                    <p>李四</p>
                                </div>
                            </div>
                            <div class="person_score">
                               <span>2</span>
                            </div>
                            <div class="person_points">
                                <div>vs</div>
                                <div class="curren_points">
                                    <span>21:9</span>
                                    <!-- <span :style="{'font-size':'14px'}">啥的是是&阿萨德啊</span> -->
                                </div>
                                <div class="ending_points">
                                    <span>21:8<i>,</i></span>
                                    <span>21:14<i></i></span>
                                </div>
                            </div>
                            <div class="person_score">
                               <span>1</span>
                            </div>
                            <div class="person_startTime" :style="{'width':'13%','text-align':'center'}">
                                <P>北京</P>
                                <div class="name_athlete">
                                    <p>张三</p>
                                    <p>李四</p>
                                </div>
                            </div>
                            <div>40分钟</div>

                        </div>
                    </template>
                </el-collapse-item>
                <!-- :style="{'margin-top':'20px'}" -->
                <!-- 团体 -->
                <el-collapse-item name="2">
                    <template slot="title">
                        <div class="result_person">
                            <div class="status_game"></div>
                            <div class="person_second">
                                <div class="person_startTime person_secondOne">
                                    <div>开始时间：09:00</div>
                                    <div :style="{'height':'30px'}"></div>
                                    <div class="event_name">团体比赛1/128淘汰赛</div>
                                </div>
                                <div class="person_startTime person_secondTwo">
                                    <P>混合团体</P>
                                </div>
                                <div class="person_startTime person_secondThree" :style="{'text-align':'right'}">
                                    <P>1号场地</P>
                                    <div :style="{'height':'30px'}"></div>
                                    <!-- <P class="event_name">主裁：<span>发球裁判</span>，发裁：<span>发球裁判</span></P> -->
                                </div>
                            </div>
                            <div class="person_startTime" :style="{'width':'13%','text-align':'center'}">
                                <div class="name_athlete">
                                    <p>北京</p>
                                </div>
                            </div>
                            <div class="person_score">
                               <span>5</span>
                            </div>
                            <div class="person_points">
                                <div>vs</div>
                            </div>
                            <div class="person_score">
                               <span>0</span>
                            </div>
                            <div class="person_startTime" :style="{'width':'13%','text-align':'center'}">
                                <div class="name_athlete">
                                    <p>上海</p>
                                </div>
                            </div>
                            <div>440分钟</div>

                        </div>
                    </template>
                    <template>
                        <ul class="teamResult">
                            <li>
                                <div class="listOne" >
                                    <div class="listOne_one">第一场</div>
                                    <div class="listOne_two">混合双打</div>
                                    <div class="listOne_three">主裁：住专票，发裁：发球裁判</div>
                                </div>
                                <div class="listTwo">
                                    <p>张三</p>
                                    <p>李四</p>
                                </div>
                                <div class="person_score" :style="{'font-size':'30px'}"><span>2</span></div>
                                <div class="person_points" :style="{'font-size':'16px'}">
                                    <div>vs</div>
                                    <div class="curren_points" :style="{'background':'#3641C9','color':'white'}">
                                        <span>21:9</span>
                                        <!-- <span :style="{'font-size':'14px'}">啥的是是&阿萨德啊</span> -->
                                    </div>
                                    <div class="ending_points" :style="{'font-size':'14px'}">
                                        <span>21:8<i>,</i></span>
                                        <span>21:14<i></i></span>
                                    </div>
                                </div>
                                <div class="person_score" :style="{'font-size':'30px'}"><span>1</span></div>
                                <div class="listTwo" :style="{'margin-left':'20px'}">
                                    <p>张三</p>
                                    <p>李四</p>
                                </div>
                                <div>42分钟</div>
                            </li>
                            <li>
                                <div class="listOne" >
                                    <div class="listOne_one">第一场</div>
                                    <div class="listOne_two">混合双打</div>
                                    <div class="listOne_three">主裁：住专票，发裁：发球裁判</div>
                                </div>
                                <div class="listTwo">
                                    <p>张三</p>
                                    <p>李四</p>
                                </div>
                                <div class="person_score" :style="{'font-size':'30px'}"><span>2</span></div>
                                <div class="person_points" :style="{'font-size':'16px'}">
                                    <div>vs</div>
                                    <div class="curren_points" :style="{'background':'#3641C9','color':'white'}">
                                        <span>21:9</span>
                                        <!-- <span :style="{'font-size':'14px'}">啥的是是&阿萨德啊</span> -->
                                    </div>
                                    <div class="ending_points" :style="{'font-size':'14px'}">
                                        <span>21:8<i>,</i></span>
                                        <span>21:14<i></i></span>
                                    </div>
                                </div>
                                <div class="person_score" :style="{'font-size':'30px'}"><span>1</span></div>
                                <div class="listTwo" :style="{'margin-left':'20px'}">
                                    <p>张三</p>
                                    <p>李四</p>
                                </div>
                                <div>42分钟</div>
                            </li>
                        </ul>
                    </template>
                    <template slot="right-icon">
                        <div>
                            <div class="icons" ><i class="header-icon el-icon-info"></i></div>
                        </div>
                    </template>
                </el-collapse-item>
            </el-collapse>
        </div>


    </div>
</template>

<script>
export default {
    data() {
        return {
            options: [{
                value: '选项1',
                label: '黄金糕'
                }, {
                value: '选项2',
                label: '双皮奶'
                }, {
                value: '选项3',
                label: '蚵仔煎'
                }, {
                value: '选项4',
                label: '龙须面'
                }, {
                value: '选项5',
                label: '北京烤鸭'
                }],
            screen:{
                date: '',
                session: '',
                court: '',
                status: '',
                name:''
            },
            activeNames: [],
            
        }
    },
    mounted() {
        
    },
    methods: {
        handleChange(val) {
            console.log(val);
        }
    },
}
</script>

<style lang="scss" scoped>
    $color: #3641C9;
    .status_game{
        width: 15px;
        height: 15px;
        border-radius: 50%;
        background: wheat;
        margin-left: 10px;
    }
    .start{
        background: white;
    }
    .running{
        background: green;
    }
    .end{
        background: $color;
    }
    ::v-deep.el-select{
        margin-left: 10px;
        background: none;
        width: 150px;
        .el-input__inner{
            background: none;
            border: 1px solid $color;
            // border: none;
        }
        .el-input__inner::placeholder{
            color: $color;
        }
    }
    .adb{
        width: 160px;
        margin-left: 10px;
        border:1px solid $color;
        border-radius: 4px,
    }
    .el-input__inner::placeholder{
        color: $color;
    }
    .GamesResults_children{
        font-size: 16px;
    }
    .screen_box{
        padding: 10px;
        border-bottom: 1px solid $color;
        display: flex;
        align-items: center;
        label{
            margin-left: 10px;
            color: $color;
            font-weight: bold;
        }
    }
    .gameschildren_list{
        padding: 20px;
    }
    ::v-deep.el-collapse{
        border: none;
    }
    ::v-deep .el-collapse-item{
        margin-top: 20px;
        border-radius: 5px;
        box-shadow: 5px 5px 10px 0px rgba(0, 0, 0, 0.5);
        // color: white;
    }
    /* 覆盖展开状态下的边框颜色 */
    ::v-deep .el-collapse-item__header {
        border-color: $color; /* 你想要的颜色 */
        background-color: $color;
        color: white;
        padding: 10px;
        border-radius: 5px;        
        height: auto;
        line-height: normal;
    }
    ::v-deep .el-collapse-item__header > .el-collapse-item__arrow{
        // content: '';
        display: none;
    }
    // ::v-deep.el-icon-arrow-right{
    //     // content: '';
    //     display: none;
    // }

    .result_person{
        width: 100%;
        display: flex;
        color: white;
        align-items: center;
        .person_second{
            display: flex;
            width: 42%;
            // min-height: 60px;
            .person_secondOne{
                width: 30%;
            }
            .person_secondTwo{
                width: 20%;
            }
            .person_secondThree{
                width: 40%;
            }
        }
        .person_startTime{
            margin-left: 20px;
            // width: 15%;
            p{
                line-height: normal;
                // line-height: 30px;
            }
            .event_name{
                // margin-top: 12px;
            }
            .name_athlete{
                font-size: 20px;
                font-weight: bold;
                p{
                    margin-top: 5px;
                    // line-height: normal;
                }
            }
        }
        
        
    }
    .person_points{
        width: 12%;
        text-align: center;
        margin:0 20px;
        font-size: 20px;
        .curren_points{
            width: 100%;
            // height: 30px;
            line-height: 30px;
            border-radius: 30px;
            background: rgba(255,255,255,0.5);
            color: $color;
            font-weight: bold;
        }
        .ending_points{
            font-size: 16px;
            font-weight: bold;
        }   
    }
    .person_score{
        font-size: 40px;
        font-weight: bold;
        width: 3%;
        text-align: center;
        // line-height: 80px;
    }
    .teamResult{
        padding: 10px;
        li{
            color: $color;
            display: flex;
            align-items: center;
            padding: 10px 0;
            border-bottom: 2px solid;
            border-image: radial-gradient(circle,  rgb(120,132,177),white);
            border-image-slice: 1;
            // font-size: 1;
            .listOne{
                display: flex;
                width:42%;
                margin-left:45px;
                .listOne_one{
                    width: 30%;
                }
                .listOne_two{
                    width: 20%;
                    margin-left: 20px;
                }
                .listOne_three{
                    width: 40%;
                    text-align: right;
                    margin-left: 20px;
                }
            }
            .listTwo{
                width: 13%;
                // margin-left: 20px;
                text-align: center;
                font-size: 20px;
                font-weight: bold;
            }
            
           
        }
    }
</style>